import React from 'react';
import { Card } from '~/components/Card';
import { BackButton } from '~/components/BackButton';
import { ServicesContext } from '~/services';

export function Resources() {
    const context = React.useContext(ServicesContext);
    const resources = [
        {
            title: 'ePRG eTool Resources',
            href: 'https://eprg.wellmed.net/eTools/ProviderMemberListNew',
        },
        {
            title: 'Member in Context Download',
            href: 'https://chrome.google.com/webstore/detail/zephyr-mic/ecfijpjflodeinpllfgnnglfpoailoab',
        },
        {
            title: 'Quality Resources',
            href: 'https://wellmedquality.com/',
        },
        ...(context.user.hasFeatureToggle('hidden_foc')
            ? []
            : [
                  {
                      title: 'AgeWise: Training Resources',
                      href: 'https://d29lq17xzvjvqy.cloudfront.net/Provider_videos/docs/AgeWise_resource_guide_WellMed.pdf',
                  },
              ]),
        {
            title: 'Reporting',
            href: 'https://bi-reporting.optum.com/#/site/W_South_WellMed/views/ZephyrBig8Report/Big8?:embed=yes',
        },
    ];
    const userGuides = [
        {
            title: 'Attestation',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+Attestation.pdf',
        },
        {
            title: 'Dashboard and Patient Search',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+Dashboard+and+Patient+Search.pdf',
        },
        {
            title: 'Member in Context Overview',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+Member+in+Context.pdf',
        },
        {
            title: 'Quality',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+Quality.pdf',
        },
        {
            title: 'Referral Overview',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/WellMed_Zephyr_Guide.pdf',
        },
        {
            title: 'Sign In',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+Sign+In.pdf',
        },
        {
            title: 'User Information',
            href: 'https://d29lq17xzvjvqy.cloudfront.net/Zephyr/documents/Zephyr+User+Guide+-+User+Settings.pdf',
        },
    ];

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <Card
                        className="mb-3"
                        title={
                            <span>
                                <BackButton />
                                Contact Support
                            </span>
                        }
                    >
                        <div>
                            Email: <a href="mailto: HelpDesk@wellmed.net">HelpDesk@wellmed.net</a>
                        </div>
                        <div>Phone: 1-877-435-7576</div>
                    </Card>
                    <Card title="Resources" className="mb-3">
                        <div className="container pb-2">
                            <div className="row gy-5 ">
                                {resources.map((resource) => (
                                    <div
                                        key={resource.title}
                                        className=" col-12 col-md-6 col-lg-4 gx-5"
                                    >
                                        <a
                                            className="resource-link"
                                            href={resource.href}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {resource.title}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card>
                    <Card title="User Guides">
                        <div className="container pb-2">
                            <div className="row gy-5 ">
                                {userGuides.map((guide) => (
                                    <div
                                        key={guide.title}
                                        className=" col-12 col-md-6 col-lg-4 gx-5"
                                    >
                                        <a
                                            className="resource-link"
                                            href={guide.href}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {guide.title}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}
